import React from 'react';
import type { ShipmentLabelView } from '../../api/generated/models/ShipmentLabelView';

interface ShipmentLabelChipProps {
  label: Pick<ShipmentLabelView, 'name' | 'color'>;
  className?: string;
}

const ShipmentLabelChip: React.FC<ShipmentLabelChipProps> = ({
  label,
  className = '',
}) => (
  <span
    className={`shipment-label-chip shipment-label-chip--${label.color} ${className}`.trim()}
  >
    <span className="shipment-label-chip__dot" aria-hidden="true" />
    <span className="shipment-label-chip__name">{label.name}</span>
  </span>
);

export default ShipmentLabelChip;
